import Analytics from "@repo/utils/Analytics";
import UObject from "@repo/utils/UObject";
import Platform from "@repo/utils-client/Platform";
import AppRouter from "@repo/utils-solid/AppRouter";

import { OverlayKey } from "~/overlays/index.jsx";
import { useUser } from "~/state/features/user";

type Events = {
  conversion: {
    Signup: {};
  };
  analytics: {
    "view page":
      | {
          initial: true;
        }
      | {
          initial: false;
          from: string;
        };
    "overlay: push": { key: OverlayKey; props: any };
    "404": {};
    "signup: attempt": {};
    "signup: succeeded": {};
    "signup: authenticated": {};
    "signup: failed": {
      errors: string[];
    };
    "login: attempt": {};
    "login: succeeded": {};
    "login: failed": {
      errors: string[];
    };
    "sentry: send": {
      message: string | undefined;
      filestack: (string | undefined)[] | undefined;
      frames: any;
      suppress: boolean;
    };
    "onboarding: confirm email attempt": {
      status: "success" | "error" | "invalid";
    };
  };
  other: {
    // Not meant to be populated
  };
};

const base = new Analytics<
  Events,
  {
    user: ReturnType<typeof useUser>[0];
  }
>();

export declare namespace Registration {
  type Analytics = ReturnType<
    Parameters<typeof base.addClient<"analytics", string>>[2]
  >;
  type Conversion = ReturnType<
    Parameters<typeof base.addClient<"conversion", string>>[2]
  >;
  type Other = ReturnType<
    Parameters<typeof base.addClient<"other", string>>[2]
  >;
}

const clients =
  // prettier-ignore
  import.meta.glob("./clients/*/*.ts", {
  eager: true,
  import: "default",
}) as {
/* GENERATED */ "./clients/analytics/amplitude.ts": typeof import("./clients/analytics/amplitude.ts")["default"],
/* GENERATED */ "./clients/other/sentry.ts": typeof import("./clients/other/sentry.ts")["default"]
};

const analytics = !Platform.isClient
  ? (base as never)
  : base
      .setBaseProperties(() => ({
        path: (() => {
          // We cannot always guarantee analytics.track won't be called after
          // AppRouter is registered. If it is AppRouter will throw, fall back
          // to window path
          try {
            return AppRouter.pathname;
          } catch (e) {
            return window.location.pathname;
          }
        })(),
        "user agent": window.navigator.userAgent,
        community: true,
      }))
      .addClients(UObject.trimKeys(clients, "./clients/", ".ts"));

export default analytics;
export const track = analytics.track.bind(analytics);
